import React from "react";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { Button } from "@pgs-core/ui/components/button";
import { LogIn } from "lucide-react";
import { SectionTabs } from "@pgs-core/ui/components/section-tabs";
import {
  canOpenClientPortal,
  openClientPortal,
  openClientPortalTitle,
} from "../lib/open-client-portal";
import type { AdminOutletContext } from "../lib/outlet-context";

// Layout for /clients/:clientId/* — renders the client name + section tabs,
// then the active sub-page via a nested Outlet. Re-provides the outlet context
// so child pages keep their useOutletContext() access. The "Open Client Portal"
// action lives here so it's available across every client tab.
export function ClientLayout() {
  const ctx = useOutletContext<AdminOutletContext>();
  const { clientId } = useParams();
  const client = ctx.clients.find((c) => c.id === clientId);
  const base = `/clients/${clientId}`;

  const tabs = [
    { label: "Overview", href: base, end: true },
    { label: "Users", href: `${base}/users` },
    { label: "Branding", href: `${base}/branding` },
    { label: "Modules", href: `${base}/modules` },
    { label: "Usage", href: `${base}/usage` },
    { label: "Billing", href: `${base}/billing` },
  ];

  const canOpenPortal = canOpenClientPortal(client, ctx.api);

  return (
    <div>
      <SectionTabs
        sticky
        items={tabs}
        action={
          <Button
            size="sm"
            variant="outline"
            onClick={() => client && openClientPortal(client, ctx.api, ctx.user)}
            disabled={!canOpenPortal}
            title={openClientPortalTitle(client)}
          >
            <LogIn className="h-3.5 w-3.5" />
            Open Client Portal
          </Button>
        }
      />
      <Outlet context={ctx} />
    </div>
  );
}
